import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore/lite';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

 const firebaseConfig = {
   apiKey: "AIzaSyCQJHRwVGF2X8Vb4V6Lp7GLOyHdBF412EU",
   authDomain: "your-city-partner.firebaseapp.com",
   projectId: "your-city-partner",
   storageBucket: "your-city-partner.firebasestorage.app",
   messagingSenderId: "289364850072",
   appId: "1:289364850072:web:fe42f0c7a21b8ed66e27ed",
   measurementId: "G-XTW1CPYFRR"
 };

const app = initializeApp(firebaseConfig);

export async function uploadFileAndReturnPath(storagePath, file) {
  const storage = getStorage();
  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file);

  // Return only the path string for persistence in privateData
  return storagePath;
}

export function buildDeterministicStoragePath({ userId, fieldName }) {
  const safeField = String(fieldName).replace(/[^a-zA-Z0-9_-]/g, "_");
  return `banners/${userId}/${safeField}`;
}

export const storage = getStorage(app);

export const db = getFirestore(app);
